<template>
  <PageHeaderLayout>
    <div class="main-page-content">
      <div class="sub-page-header">
        <div>
          <el-button size="mini" icon="el-icon-arrow-left" @click="backToBillList">返回</el-button>
          <span class="sub-page-title">发票详情</span>
        </div>
        <div class="sub-page-info">
          <span>{{ currentBill.company_name }}</span>
          <span>{{ currentBill.channel_name }}</span>
          <span>已开票金额：{{ openedSummary.opened_invoice_amount || currentBill.opened_invoice_amount || '0.00' }}</span>
        </div>
      </div>

      <div class="table-toolbar">
        <el-button type="primary" size="mini" :disabled="!selectedOpenedRows.length" @click="downloadSelectedInvoices">
          下载发票
        </el-button>
      </div>

      <ApeTable
        ref="openedTable"
        :data="openedList"
        :columns="openedColumns"
        :loading="loadingStaus"
        :pagingData="openedPagingData"
        highlight-current-row
        @selectList="handleOpenedSelection"
        @switchPaging="switchOpenedPaging"
      >
        <el-table-column slot="first-column" type="selection" width="55" align="center" />
        <el-table-column align="center" label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              v-if="canViewInvoice(scope.row)"
              size="mini"
              @click="showDetail(scope.row)"
            >
              查看
            </el-button>
            <el-button
              v-if="canDownloadInvoice(scope.row)"
              size="mini"
              type="text"
              @click="openRowDownload(scope.row)"
            >
              下载发票
            </el-button>
          </template>
        </el-table-column>
      </ApeTable>

      <el-dialog
        title="开票详情"
        :visible.sync="detailDialogVisible"
        width="640px"
      >
        <div v-if="detailInfo" class="detail-grid">
          <div class="detail-item">
            <span class="detail-label">申请编号</span>
            <span>{{ detailInfo.apply_sn || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">状态</span>
            <span>{{ detailInfo.status_desc || detailInfo.status_alias || detailInfo.status || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">发票ID</span>
            <span>{{ detailInfo.invoice_id || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">开票金额</span>
            <span>{{ detailInfo.invoice_amount || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">开票类目</span>
            <span>{{ detailInfo.invoice_content || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">发票类型</span>
            <span>{{ formatInvoiceType(detailInfo.invoice_type) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">公司</span>
            <span>{{ detailInfo.company_name }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">税源地</span>
            <span>{{ detailInfo.channel_name }}</span>
          </div>
        </div>
        <div slot="footer">
          <el-button @click="detailDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>
    </div>
  </PageHeaderLayout>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
  },
  data() {
    return {
      loadingStaus: false,
      currentBill: {},
      openedList: [],
      selectedOpenedRows: [],
      openedSummary: {},
      openedPagingData: this.createPagingData(),
      openedColumns: [
        { title: '记录ID', value: 'id', width: 100, header_align: 'center', align: 'center' },
        { title: '申请编号', value: 'apply_sn', width: 160, header_align: 'center', align: 'center' },
        { title: '发票ID', value: 'invoice_id', width: 140, header_align: 'center', align: 'center' },
        { title: '开票金额', value: 'invoice_amount', width: 120, header_align: 'center', align: 'center' },
        { title: '开票类目', value: 'invoice_content', header_align: 'center', align: 'center' },
        { title: '发票类型', value: 'invoice_type_desc', width: 130, header_align: 'center', align: 'center' },
        { title: '状态', value: 'status_desc', width: 120, header_align: 'center', align: 'center' },
      ],
      detailDialogVisible: false,
      detailInfo: null,
    }
  },
  methods: {
    createPagingData() {
      return {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
      }
    },
    initCurrentBill() {
      const query = this.$route.query || {}
      this.currentBill = {
        company_id: query.company_id,
        channel_account: query.channel_account,
        company_account_id: query.company_account_id,
        company_name: query.company_name,
        channel_name: query.channel_name,
        opened_invoice_amount: query.opened_invoice_amount,
      }
    },
    buildCommonParams(row = {}) {
      const companyId = row.company_id || this.currentBill.company_id || this.mxCompanyId
      const channelAccount = row.channel_account || this.currentBill.channel_account || this.mxSettlementId
      const companyAccountId = row.company_account_id || this.currentBill.company_account_id
      const params = {}
      if (companyId) params.company_id = companyId
      if (channelAccount) params.channel_account = channelAccount
      if (companyAccountId) params.company_account_id = companyAccountId
      return params
    },
    getPagingInfo(refName, type) {
      const table = this.$refs[refName]
      if (table && table.getPagingInfo) {
        const pagingInfo = table.getPagingInfo(type)
        if (type === 'search') {
          pagingInfo.current_page = 1
        }
        return pagingInfo
      }
      return { current_page: 1, page_size: 10 }
    },
    normalizeListResp(result) {
      if (!result) {
        return { list: [], pages: { total: 0 } }
      }
      if (Array.isArray(result)) {
        return { list: result, pages: { total: result.length } }
      }
      return {
        list: result.data || result.list || [],
        pages: result.pages || { total: (result.data || result.list || []).length },
      }
    },
    async loadOpenedRecords(type) {
      this.loadingStaus = true
      const params = {
        ...this.buildCommonParams(this.currentBill),
        ...this.getPagingInfo('openedTable', type),
      }
      try {
        const result = await this.$api.getNewTaxInvoiceOpenedRecords(params)
        const { list, pages } = this.normalizeListResp(result)
        this.openedSummary = {
          opened_invoice_amount: result && result.opened_invoice_amount,
        }
        this.openedList = list.map((row) => ({
          ...row,
          invoice_type_desc: this.formatInvoiceType(row.invoice_type),
          status_desc: row.status_desc || row.status_alias || row.status || '-',
        }))
        this.openedPagingData.total = (pages && pages.total) || 0
        this.openedPagingData.page_size = pages && pages.page_size
        this.openedPagingData.offset = pages && pages.offset
      } finally {
        this.loadingStaus = false
      }
    },
    switchOpenedPaging() {
      this.loadOpenedRecords()
    },
    handleOpenedSelection(list) {
      this.selectedOpenedRows = list || []
    },
    canViewInvoice(row) {
      if (row.can_view_invoice === false) return false
      return row.status_code !== 'rejected'
    },
    canDownloadInvoice(row) {
      if (row.can_download_invoice === false) return false
      if (row.status_code === 'rejected') return false
      return this.parseUrlList(row.download_urls).length ||
        this.parseUrlList(row.pdf_oss_urls).length ||
        this.parseUrlList(row.invoice_file).length
    },
    async showDetail(row) {
      const id = row.id || row.invoice_id
      if (!id) {
        this.$message.warning('记录ID不存在')
        return
      }
      const detail = await this.$api.getNewTaxInvoiceDetail(id, this.buildCommonParams(this.currentBill))
      this.detailInfo = detail || {}
      this.detailDialogVisible = true
    },
    async downloadSelectedInvoices() {
      if (!this.selectedOpenedRows.length) {
        this.$message.warning('请选择要下载的发票')
        return
      }
      const ids = this.selectedOpenedRows.map((row) => row.id)
      const result = await this.$api.downloadNewTaxInvoiceOpenedRecords({ ids })
      this.openUrls((result && result.file_urls) || [])
      if (result && result.missing_ids && result.missing_ids.length) {
        this.$message.warning(`部分记录暂无下载地址：${result.missing_ids.join(',')}`)
      }
    },
    openRowDownload(row) {
      const urls = []
        .concat(this.parseUrlList(row.download_urls))
        .concat(this.parseUrlList(row.pdf_oss_urls))
        .concat(this.parseUrlList(row.invoice_file))
      this.openUrls(urls)
    },
    openUrls(urls) {
      const list = this.uniqueList(this.parseUrlList(urls))
      if (!list.length) {
        this.$message.warning('暂无可下载发票')
        return
      }
      list.forEach((url) => window.open(url, '_blank'))
    },
    parseUrlList(value) {
      if (!value) return []
      if (Array.isArray(value)) return value.filter(Boolean)
      if (typeof value === 'string') {
        try {
          const json = JSON.parse(value)
          if (Array.isArray(json)) return json.filter(Boolean)
        } catch (e) {
          return value ? [value] : []
        }
        return value ? [value] : []
      }
      return []
    },
    uniqueList(list) {
      return Array.from(new Set(list))
    },
    backToBillList() {
      this.$router.push('/new_tax_invoice')
    },
    formatInvoiceType(value) {
      const type = String(value || '')
      if (type === '1') return '增值税专票'
      if (type === '2') return '增值税普票'
      return value || '-'
    },
  },
  mounted() {
    this.initCurrentBill()
    this.loadOpenedRecords('search')
  },
}
</script>

<style lang="scss" scoped>
.sub-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.sub-page-title {
  margin-left: 12px;
  font-size: 16px;
  font-weight: 600;
}

.sub-page-info span {
  margin-left: 18px;
  color: #606266;
}

.table-toolbar {
  margin-bottom: 12px;
  text-align: right;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  border-top: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
}

.detail-item {
  display: flex;
  min-height: 40px;
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

.detail-label {
  width: 88px;
  padding: 10px;
  background: #fafafa;
  color: #606266;
}

.detail-item span:last-child {
  flex: 1;
  padding: 10px;
}
</style>
